import React from 'react';
import DebtForm from '../components/DebtForm';
import DebtList from '../components/DebtList';

export default function Home() {
  const [reload, setReload] = React.useState(false);
  return (
    <div>
      <h2><center>Catatan Hutang</center></h2>
      <DebtForm onAdd={() => setReload(!reload)} />
      <DebtList key={reload} />
    </div>
  );
}
